module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/data.js
// module id = 25
// module chunks = 1 2 3 4